import React from 'react'
import { Avatar, Card, Table, Form } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { fetchNotificationUserList } from '../../modules/notification'
import _ from 'lodash'
import moment from 'moment'
import g2gImage from '../../assets/images/g2g.png'
import heroImage from '../../assets/images/icon_hero_green2get.png'

const NotificationUser = () => {
  const dispatch = useDispatch()

  const { notificationUserList, isLoading } = useSelector(
    (state) => ({
      notificationUserList: state.notification.notificationUserList,
      isLoading: state.notification.isLoading
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchNotificationUserList())
    }

    fetch()
  }, [])

  const columns = [
    {
      title: 'App',
      dataIndex: 'userReceiverTypeId',
      key: 'logo',
      align: 'center',
      width: 80,
      render: (userReceiverTypeId, record) =>
        userReceiverTypeId === 2 ? (
          <Avatar src={g2gImage} size={36} shape="square" />
        ) : (
          <Avatar src={heroImage} size={36} shape="square" />
        )
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      render: (text, _) => <span>{text}</span>
    },
    {
      title: 'Text',
      key: 'message',
      dataIndex: 'message',
      render: (text, _) => <span>{text}</span>
    },
    {
      title: 'User',
      key: 'user',
      dataIndex: 'user',
      render: (text, _) => <span>{text}</span>
    },
    {
      title: 'Date sent',
      key: 'dateSent',
      dataIndex: 'dateSent',
      render: (text, _) => (
        <span>{moment(text).format('D/MMMM/YYYY HH:mm')}</span>
      )
    }
  ]

  return (
    <Card title="Notification User">
      <Table
        bordered
        loading={isLoading}
        dataSource={notificationUserList}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
        pagination={{
          pageSize: notificationUserList.size,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          total: notificationUserList.totalElements
        }}
      />
    </Card>
  )
}

const WrappedNotificationUser = Form.create({
  name: 'NotificationUser'
})(NotificationUser)

export default WrappedNotificationUser
